import { lazyPage } from 'utils/chunkReload';

const SignIn1 = lazyPage(
  () => import('../Containers/Authentication/SignIn'),
  'SignIn1',
);
const ResetPassword = lazyPage(
  () => import('../Containers/Authentication/ResetPassword'),
  'ResetPassword',
);
const ClientSetup = lazyPage(() => import('modules/OnBoarding'), 'ClientSetup');

const ChangePassword = lazyPage(
  () => import('Containers/Authentication/ChangePassword'),
  'ChangePassword',
);
const customerPayment = lazyPage(
  () => import('modules/CustomerPayment'),
  'customerPayment',
);

const ConsolidatePayment = lazyPage(
  () => import('modules/ConsolidatedInvoice/ConsolidatePayment'),
  'modules/ConsolidatedPayment',
);

const customerPortalInvoice = lazyPage(
  () => import('views/customerPortal/ViewInvoice'),
  'customerPortalInvoice',
);
const customerPortalEstimatesOld = lazyPage(
  () => import('views/customerPortal/Estimates/EstimatesView'),
  'customerPortalEstimates',
);
const customerPortalEstimates = lazyPage(
  () => import('views/customerPortal/NewEstimates'),
  'customerPortalEstimates',
);
const alarmSystemInfoView = lazyPage(
  () =>
    import(
      'views/customerPortal/public/System/views/AlarmSystemInformationView'
    ),
  'alarmSystemInfoView',
);

const customerPortal = lazyPage(
  () => import('views/customerPortal/Dashboard.jsx'),
  'customerPortal',
);
const customerSignIn = lazyPage(
  () => import('views/customerPortal/SignIn.js'),
  'customerSignIn',
);
const customerSignUp = lazyPage(
  () => import('views/customerPortal/SignUp.js'),
  'customerSignUp',
);
const customerSignUpUser = lazyPage(
  () => import('views/customerPortal/SignUpUser.jsx'),
  'customerSignUpUser',
);

const customerInvoices = lazyPage(
  () => import('views/customerPortal/Invoices.js'),
  'customerInvoices',
);
const customerPayInvoice = lazyPage(
  () => import('views/customerPortal/PayInvoice.jsx'),
  'customerPayInvoice',
);
const customerAccountVerification = lazyPage(
  () => import('views/customerPortal/AccountVerification.jsx'),
  'customerAccountVerification',
);
const privacyPolicy = lazyPage(
  () => import('Containers/Authentication/PrivacyPolicy'),
  'privacyPolicy',
);
const termsOfService = lazyPage(
  () => import('Containers/Authentication/TermsOfService'),
  'termsOfService',
);

const GoalsOpenLinkDashboard = lazyPage(
  () => import('modules/Settings/Goals/GoalsDashboard'),
  'GoalsDashboard',
);

const route = [
  { path: '/', exact: true, name: 'Signin', component: SignIn1 },
  {
    path: '/reset',
    exact: true,
    name: 'Reset Password',
    component: ResetPassword,
  },
  {
    path: '/clientsetup',
    exact: true,
    name: 'Client Setup',
    component: ClientSetup,
  },
  {
    path: '/Goals-open-link/:hash',
    exact: true,
    name: 'GoalsOpenLinkDashboard',
    component: GoalsOpenLinkDashboard,
  },
  {
    path: '/change-password/:token/:email',
    exact: true,
    name: 'Change Password',
    component: ChangePassword,
  },
  {
    path: '/privacyPolicy',
    exact: true,
    name: 'Privacy Ploicy',
    component: privacyPolicy,
  },
  {
    path: '/customerPayment/:reference',
    exact: true,
    name: 'Customer',
    component: customerPayment,
  },
  {
    path: '/consolidated-invoice/pay/:reference',
    exact: true,
    name: 'ConsolidatePayment',
    component: ConsolidatePayment,
  },
  {
    path: '/customer-portal-invoice/:reference',
    exact: true,
    name: 'Customer',
    component: customerPortalInvoice,
  },
  {
    path: '/customer-portal-estimates/:reference/:tab',
    exact: true,
    name: 'Customer',
    component: customerPortalEstimates,
  },
  {
    path: '/customer-portal-estimates-old/:reference',
    exact: true,
    name: 'Customer old estimate',
    component: customerPortalEstimatesOld,
  },
  {
    path: '/customer-portal-systems/alarm-system-info',
    exact: true,
    name: 'Alarm System Info',
    component: alarmSystemInfoView,
  },
  {
    path: '/customerPortal',
    exact: true,
    name: 'Portal',
    component: customerPortal,
  },
  {
    path: '/customer/signin',
    exact: true,
    name: 'Customer SignIn',
    component: customerSignIn,
  },
  {
    // http://localhost:3000/customer/accept-invitation/44906
    path: '/customer/accept-invitation/:invite_code',
    exact: true,
    name: 'Customer SignUp',
    component: customerSignUp,
  },
  {
    path: '/customer/signup/:invite_code',
    exact: true,
    name: 'Customer SignUp User',
    component: customerSignUpUser,
  },
  {
    path: '/customer/invoices',
    exact: true,
    name: 'Customer Invoices',
    component: customerInvoices,
  },
  {
    path: '/customer/payinvoice',
    exact: true,
    name: 'Pay Invoices',
    component: customerPayInvoice,
  },
  {
    path: '/customer/account-verification',
    exact: true,
    name: 'Customer Account Verification',
    component: customerAccountVerification,
  },
  {
    path: '/termsOfService',
    exact: true,
    name: 'Terms Of Service',
    component: termsOfService,
  },
];

export default route;
